/**
 * Split tests to use in the app
 * Can be passed as a string (name) or an object with configuration
 * See defaults in split-test duck for default variants and other available options
 * @type {String|Array.Object}
 */

module.exports = [
  'ByobPricePerItemOnCards', // Test 359
  // 'HomePageLimitedTimeDeals', // Test 459
  'TopSellerPageHitCards', // Test 480
  'BuyWithDLCNoSystemDiscount', // Test 519
  'TieredBundleReverseOrder', // Test 520
  'FeedbackPopupRedesignV2', // Test 521
  'CategoryRevisitScrollitus', // Test 523
];
